// src/components/resize-observer/resize-observer.styles.ts
import { css } from "lit";
var resize_observer_styles_default = css`
  :host {
    display: contents;
  }
`;

export {
  resize_observer_styles_default
};
